import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TFMService } from 'app/mock-api/tfm.service';

@Component({
  selector: 'app-why_us-type05',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './why_us-type05.component.html',
  styleUrl: './why_us-type05.component.scss'
})
export class WhyUsType05Component implements OnInit {

  public view: any = {};

  constructor(private _tfmService: TFMService) { }

  ngOnInit(): void {

    this._tfmService.getSite().then(res => {
    this.view.site = res;

    this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
    this._tfmService.log(this.view);

  });
      
  }


}
